<ion-header>
  <div class="flex-space-between" style="padding: 15px">
    <div class="button-container flexed-align-center">
      <ion-button
        (click)="createTenant()"
        [disabled]="isLoading"
        class="hidden-sm"
      >
        <span class="hidden-sm"> Create tenant </span>
      </ion-button>
    </div>
  </div>
</ion-header>

<ion-content>
  <div class="flexed" style="height: 100%">
    <div style="width: 50%; overflow-y: scroll; overflow-x: hidden">
      <ion-card class="outline-card">
        <ion-card-header>
          <div
            style="
              display: flex;
              justify-content: space-between;
              align-items: center;
            "
          >
            <ion-card-title>Tenants</ion-card-title>
            <ion-searchbar
              mode="ios"
              class="rounded-search-bar"
              placeholder="Search tenants..."
              showCancelButton="never"
              [value]="tenantSearchText"
              (ionInput)="tenantSearchText = $event.target.value"
              style="width: 270px; margin: 0"
            >
            </ion-searchbar>
          </div>
        </ion-card-header>
        <ngx-datatable
          [limit]="1000"
          [loadingIndicator]="isLoading"
          class="material"
          [columnMode]="ColumnMode.force"
          [headerHeight]="50"
          [footerHeight]="50"
          [rowHeight]="50"
          [scrollbarH]="true"
          [rows]="
            tenants$
              | async
              | filterCollection: tenantSearchText : ['name', 'id', 'subdomain']
          "
          [selectionType]="SelectionType.single"
          [selectAllRowsOnPage]="false"
          [displayCheck]="false"
          [selected]="selected"
          trackByProp="id"
          (select)="onSelect($event)"
        >
          <ngx-datatable-column name="Name" prop="name"></ngx-datatable-column>
          <ngx-datatable-column name="ID" prop="id"></ngx-datatable-column>
          <ngx-datatable-column
            name="Subdomain"
            prop="subdomain"
          ></ngx-datatable-column>
        </ngx-datatable>
      </ion-card>
    </div>
    <div style="width: 50%; overflow-y: scroll; overflow-x: hidden">
      <ion-card class="outline-card" *ngIf="selectedTenant">
        <ion-card-header>
          <h1 class="no-margin">{{ selectedTenant.name }}</h1>
        </ion-card-header>
        <ion-card-content>
          <div class="admin-settings-title-section">
            <h2 style="font-weight: bold">Account Settings</h2>
          </div>
          <ion-list>
            <ion-item>
              <ion-label> Status </ion-label>
              <ion-input [(ngModel)]="selectedTenant.accountStatus"></ion-input>
            </ion-item>
            <ion-item>
              <ion-label> Trial end </ion-label>
              <ion-input [(ngModel)]="selectedTenant.trialEndDate"></ion-input>
            </ion-item>
            <ion-item>
              <ion-label slot="start"> Billing </ion-label>
              <ion-textarea [(ngModel)]="billing"> </ion-textarea>
            </ion-item>
            <ion-item>
              <ion-checkbox
                [(ngModel)]="selectedTenant.autoSplittingEnabled"
              ></ion-checkbox>
              Auto splitting enabled
            </ion-item>
            <ion-item>
              <ion-checkbox
                [(ngModel)]="selectedTenant.moveToNeedsResponse"
              ></ion-checkbox>
              Move conversations to needs response
            </ion-item>
            <ion-item>
              <ion-checkbox
                [(ngModel)]="selectedTenant.doNotReopenConversationsOnReply"
              ></ion-checkbox>
              Do not re-open conversations on reply
            </ion-item>
            <ion-item>
              <ion-checkbox
                [(ngModel)]="
                  selectedTenant.disableConversationsStartedByInternalUser
                "
              ></ion-checkbox>
              Do not create a conversation when an external user replies to a
              thread created by an internal user
            </ion-item>
            <ion-item>
              <ion-checkbox
                [(ngModel)]="selectedTenant.isInternalSupport"
              ></ion-checkbox>
              Is for internal support use-case
            </ion-item>
            <ion-item>
              <ion-button (click)="updateTenant()" [disabled]="isLoading"
                >Save Changes</ion-button
              >
            </ion-item>
          </ion-list>
          <div class="admin-settings-title-section">
            <h2 style="font-weight: bold">Enable Features</h2>
            <p class="admin-settings-title-section-subtitle">
              Pressing these buttons will enable a feature for a tenant, and
              potentially trigger background tasks with relevant updates.
            </p>
          </div>
          <ion-list>
            <ion-item>
              <ion-label
                >Enable automations
                <ion-icon
                  name="information-circle"
                  class="icon-padded-left"
                  ngxTippy
                  data-tippy-content="This action is for turning on automations for a tenant."
                ></ion-icon>
              </ion-label>
              <ion-button
                (click)="enableAutomations()"
                [disabled]="isLoading || selectedTenant.isCustomActionsEnabled"
                >Enable automations</ion-button
              >
            </ion-item>
            <ion-item>
              <ion-label
                >Migrate from Customers to Accounts
                <ion-icon
                  name="information-circle"
                  class="icon-padded-left"
                  ngxTippy
                  data-tippy-content="This action is for turning on accounts for a tenant."
                ></ion-icon>
              </ion-label>
              <ion-button
                (click)="enableAccounts()"
                [disabled]="isLoading || selectedTenant.accountsEnabled"
                >Enable accounts</ion-button
              >
            </ion-item>
            <ion-item>
              <ion-label
                >Escalations
                <ion-icon
                  name="information-circle"
                  class="icon-padded-left"
                  ngxTippy
                  data-tippy-content="This action enables or disables escalations for a tenant."
                ></ion-icon>
              </ion-label>
              <ion-button
                (click)="
                  toggleEscalations(
                    !selectedTenant.featureFlags?.escalationsEnabled
                  )
                "
                [disabled]="isLoading"
                [color]="
                  selectedTenant.featureFlags?.escalationsEnabled
                    ? 'danger'
                    : 'primary'
                "
              >
                {{
                  selectedTenant.featureFlags?.escalationsEnabled
                    ? "Disable escalations"
                    : "Enable escalations"
                }}
              </ion-button>
            </ion-item>
            <ion-item>
              <ion-label
                >Automation Assistant
                <ion-icon
                  name="information-circle"
                  class="icon-padded-left"
                  ngxTippy
                  data-tippy-content="This action enables or disables the AI automation assistant feature for a tenant."
                ></ion-icon>
              </ion-label>
              <ion-button
                (click)="
                  toggleAutomationAssistant(
                    !selectedTenant.featureFlags?.AUTOMATION_ASSISTANT
                  )
                "
                [disabled]="isLoading"
                [color]="
                  selectedTenant.featureFlags?.AUTOMATION_ASSISTANT
                    ? 'danger'
                    : 'primary'
                "
              >
                {{
                  selectedTenant.featureFlags?.AUTOMATION_ASSISTANT
                    ? "Disable automation assistant"
                    : "Enable automation assistant"
                }}
              </ion-button>
            </ion-item>
            <ion-item>
              <ion-label
                >Knowledge Gap Analysis
                <ion-icon
                  name="information-circle"
                  class="icon-padded-left"
                  ngxTippy
                  data-tippy-content="This action enables or disables the knowledge gap analysis feature for a tenant."
                ></ion-icon>
              </ion-label>
              <ion-button
                (click)="
                  toggleKnowledgeGapAnalysis(
                    !selectedTenant.featureFlags?.knowledgeGapAnalysis
                  )
                "
                [disabled]="isLoading"
                [color]="
                  selectedTenant.featureFlags?.knowledgeGapAnalysis
                    ? 'danger'
                    : 'primary'
                "
              >
                {{
                  selectedTenant.featureFlags?.knowledgeGapAnalysis
                    ? "Disable knowledge gap analysis"
                    : "Enable knowledge gap analysis"
                }}
              </ion-button>
            </ion-item>
            <ion-item>
              <ion-label
                >Analytics Assistant
                <ion-icon
                  name="information-circle"
                  class="icon-padded-left"
                  ngxTippy
                  data-tippy-content="This action enables or disables the AI analytics assistant feature for a tenant."
                ></ion-icon>
              </ion-label>
              <ion-button
                (click)="
                  toggleAnalyticsAssistant(
                    !selectedTenant.featureFlags?.ANALYTICS_ASSISTANT
                  )
                "
                [disabled]="isLoading"
                [color]="
                  selectedTenant.featureFlags?.ANALYTICS_ASSISTANT
                    ? 'danger'
                    : 'primary'
                "
              >
                {{
                  selectedTenant.featureFlags?.ANALYTICS_ASSISTANT
                    ? "Disable analytics assistant"
                    : "Enable analytics assistant"
                }}
              </ion-button>
            </ion-item>
          </ion-list>
          <div class="admin-settings-title-section">
            <h2 style="font-weight: bold">Run Background Tasks</h2>
            <p class="admin-settings-title-section-subtitle">
              These buttons will trigger background tasks with relevant updates.
              Only idempotent background tasks should be shown here.
            </p>
          </div>
          <ion-list>
            <ion-item>
              <ion-label
                >Account sync
                <ion-icon
                  name="information-circle"
                  class="icon-padded-left"
                  ngxTippy
                  data-tippy-content="This queues a background task to convert customers to accounts (create-account-for-customer)."
                ></ion-icon>
              </ion-label>
              <ion-button
                (click)="runAccountSync()"
                [disabled]="isLoading || !selectedTenant.accountsEnabled"
                >Run Account sync</ion-button
              >
            </ion-item>
          </ion-list>
        </ion-card-content>
      </ion-card>
      <ion-card class="outline-card">
        <ion-card-header>Users</ion-card-header>
        <ion-card-content>
          <ion-input
            type="text"
            placeholder="Search"
            [(ngModel)]="userSearchString"
            (keyup.enter)="loadUsersForTenant()"
          >
          </ion-input>
        </ion-card-content>
        <ngx-datatable
          [limit]="100"
          [loadingIndicator]="isLoading"
          class="material"
          [columnMode]="ColumnMode.force"
          [headerHeight]="50"
          [footerHeight]="50"
          [rowHeight]="50"
          [scrollbarH]="true"
          [rows]="tenantUsers$ | async"
          [selectAllRowsOnPage]="false"
          [displayCheck]="false"
          trackByProp="id"
        >
          <ngx-datatable-column name="Name" prop="name"></ngx-datatable-column>
          <ngx-datatable-column
            name="Email"
            prop="email"
          ></ngx-datatable-column>
          <ngx-datatable-column name="ID" prop="id"></ngx-datatable-column>
          <ngx-datatable-column
            name="Firebase ID"
            prop="firebaseId"
          ></ngx-datatable-column>
          <ngx-datatable-column name="" prop="id" [sortable]="false">
            <ng-template
              let-row="row"
              let-value="value"
              ngx-datatable-cell-template
            >
              <a
                (click)="signInAsUser(value)"
                *ngIf="row.firebaseId"
                title="Sign in as this user in a new tab"
                ><span>Sign in as user</span></a
              >
              <span
                *ngIf="!row.firebaseId"
                title="Cannot sign in as user that has not been linked to Firebase"
                >Sign in as user</span
              >
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="" prop="id" [sortable]="false">
            <ng-template
              let-row="row"
              let-value="value"
              ngx-datatable-cell-template
            >
              <a
                (click)="resetFirebaseSettings(value)"
                title="Delete the Firebase user linked to this user"
                ><span>Reset Firebase settings</span></a
              >
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="" prop="id" [sortable]="false">
            <ng-template
              let-row="row"
              let-value="value"
              ngx-datatable-cell-template
            >
              <a
                (click)="verifyEmailAddress(value)"
                title="Verify this user's email address"
                ><span>Verify email address</span></a
              >
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </ion-card>
    </div>
  </div>
</ion-content>
